import '@/styles/hero-award-report.css'
import { useSearchParams } from 'react-router-dom'
import { useHeroAward } from '@/api/hooks'
import { HeroShortlist } from '@/components/hero-award'
import { Button } from '@/components/ui/button'
import { ReportLayout } from '@/layouts/ReportLayout'
import { triggerReportPrint } from '@/lib/print'

export default function HeroAwardReportPage() {
  const [params] = useSearchParams()
  const query = useHeroAward(params.get('showId') ?? undefined)
  const state = query.data
  // Require a fresh response for this opening; cached rows are still visible while fetching.
  const current = query.isFetchedAfterMount && !query.isError && !query.isPaused
  return (
    <ReportLayout
      className="hero-award-report"
      showWatermark={false}
      header={
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">Hero Award Eligibility Report</h1>
          <h2>{state?.showName ?? params.get('showName') ?? 'Selected show'}</h2>
          <Button
            className="print-hidden"
            variant="outline"
            disabled={!state?.enabled || !current}
            onClick={triggerReportPrint}
          >
            Print eligibility report
          </Button>
        </div>
      }
    >
      {state?.enabled ? (
        <div className="space-y-4 print:text-black print:bg-white">
          <p className="text-sm">
            Generated{' '}
            {new Date(state.generatedAt).toLocaleString(undefined, {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
            })}
          </p>
          <HeroShortlist state={state} stale={!current} />
        </div>
      ) : (
        <p>
          {query.isError
            ? 'Unable to load the current shortlist. Please retry when the connection recovers.'
            : !state
              ? 'Loading current shortlist…'
              : 'Hero Award is disabled for this show.'}
        </p>
      )}
    </ReportLayout>
  )
}
